import React from "react";
import { Link } from "react-router-dom";
import "./Terms.css";

const Terms = () => {
    return (
        <div className="terms-container">

            <div className="logo-container" style={{ filter: "brightness(0.7)" }}>
                <Link to="/">
                    <img src="/logo.png" alt="Daily Dog Logo" className="logo" />
                </Link>
                <Link to="/" className="site-title" style={{ textDecoration: "none" }}>
                    Daily Dog
                </Link>
            </div>

            <main className="terms-content">
                <h1>Terms of Service</h1>
                <p className="effective-date">Last Updated: February 27, 2025</p>

                <section className="terms-section">
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to Daily Dog! These Terms of Service ("Terms") govern your use of the Daily Dog mobile application ("App"), website, and services (collectively, the "Services") operated by Daily Dog ("we," "us," or "our"). By accessing or using our Services, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access the Services.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>2. Changes to Terms</h2>
                    <p>
                        We reserve the right to modify or replace these Terms at any time at our sole discretion. We will provide notice of any changes by updating the "Last Updated" date at the top of these Terms. It is your responsibility to check these Terms periodically for changes. Your continued use of the Services following the posting of any changes constitutes acceptance of those changes.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>3. Exercise and Activity Disclaimer</h2>
                    <p>
                        The Daily Dog app provides ideas, suggestions, and guidance for dog activities and exercises. These are provided for informational and entertainment purposes only. We do not guarantee or warrant that these activities are suitable for all dogs or all situations.
                    </p>
                    <p>
                        You acknowledge and agree that:
                    </p>
                    <ul>
                        <li>Every dog is unique and may have specific health conditions, limitations, or temperaments</li>
                        <li>You are solely responsible for assessing whether any activity is appropriate for your specific dog</li>
                        <li>You should consult with a veterinarian before beginning any new exercise regimen with your dog</li>
                        <li>You are responsible for supervising your dog during all activities</li>
                        <li>You assume all risks associated with implementing any activity ideas provided through our Services</li>
                    </ul>
                    <p>
                        Daily Dog expressly disclaims all liability for any injury, harm, or damage to you, your dog, or any third party that may result from your use of the activities, exercises, or ideas suggested through our Services.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>4. Intellectual Property</h2>
                    <p>
                        The Services and their original content, features, and functionality are and will remain the exclusive property of Daily Dog and its licensors. The Services are protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Daily Dog.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>5. Advertisements</h2>
                    <p>
                        The Services may display advertisements. By using our Services, you agree to view such advertisements as part of your use. These advertisements may be targeted based on the content of the Services, queries made through the Services, or other non-personally identifiable information.
                    </p>
                    <p>
                        We are not responsible for the content of any advertisements or any products, services, or content advertised. Any interaction with advertisers found on our Services, including the purchase of advertised products or services, is solely between you and the advertiser.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>6. Termination</h2>
                    <p>
                        We may terminate or suspend your access to the Services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Services will immediately cease.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>7. Limitation of Liability</h2>
                    <p>
                        In no event shall Daily Dog, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Services; (ii) any conduct or content of any third party on the Services; (iii) any content obtained from the Services; (iv) any injury to your dog or other pets; and (v) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>8. Disclaimer</h2>
                    <p>
                        Your use of the Services is at your sole risk. The Services are provided on an "AS IS" and "AS AVAILABLE" basis. The Services are provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
                    </p>
                    <p>
                        Daily Dog, its subsidiaries, affiliates, and its licensors do not warrant that a) the Services will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Services are free of viruses or other harmful components; or d) the results of using the Services will meet your requirements.
                    </p>
                    <p>
                        We do not provide veterinary advice. The information and content provided through our Services is not intended to replace professional veterinary advice, diagnosis, or treatment. Always seek the advice of your veterinarian with any questions you may have regarding your dog's health or wellbeing.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>9. Governing Law</h2>
                    <p>
                        These Terms shall be governed and construed in accordance with the laws of Germany, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
                    </p>
                </section>

                <section className="terms-section">
                    <h2>10. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms, please contact us at dailydog.exercises@gmail.com.
                    </p>
                </section>
            </main>

            <footer className="site-footer">
                <div className="footer-content">
                    <div className="footer-logo">
                        <img
                            src="/logo.png"
                            alt="Daily Dog Logo"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/40x40?text=DD";
                            }}
                        />
                        <h3 style={{ fontFamily: "Baloo, sans-serif" }}>Daily Dog</h3>
                    </div>
                    <div className="footer-links">
                        <div className="footer-links-column">
                            <h4>Legal</h4>
                            <ul>
                                <li><Link to="/terms">Terms of Service</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            </ul>
                        </div>
                        <div className="footer-links-column">
                            <h4>Help</h4>
                            <ul>
                                <li><Link to="/support">Support</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Daily Dog. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Terms;